import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

export const SearchLandingContainerStyles = css`
  .pod-group {
    background-color: ${colors.gray.shade57};
  }
  .pod-group--container {
    display: flex;
    flex-direction: column;
    @mixin tabletToDesktop {
      flex-direction: row;
      padding-top: 15px;
    }
  }
  .pod-group--filters {
    width: 100%;
    background: ${colors.white.shade1};
    border-top: 0;

    @mixin tabletToDesktop {
      border-bottom: 1px ${colors.gray.shade17} solid;
      border-radius: var(--border-radius);
      border: none;
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px;
      width: 22%;
    }
    @mixin desktop {
      min-width: 312px;
    }
  }
  .pod-group--products {
    width: 100%;
    margin-top: 5px;
    @mixin tabletToDesktop {
      width: 78%;
      display: flex;
      flex-direction: column;
      margin-top: 0;
    }
  }
  .filter-heading {
    padding: 20px 10px 10px 25px;
  }
  .pad-group--auto-correct {
    margin-bottom: 40px;
  }
  .pad-group--auto-correct-mkp {
    margin-bottom: 5px;
    @mixin mobileToTablet {
      margin-bottom: 23px;
    }
  }

  .pod-group--keyword-related-banner {
    margin-bottom: 15px;
  }
  .total-results {
    border-bottom: 1px solid ${colors.gray.shade14};
    padding: 8px 0;
    &.mobile {
      padding: 10px 19px;
      min-height: 39px;
      text-align: right;
    }
  }
  .location-wrapper {
    min-height: 66px;
  }
  .survey-container {
    display: none;
    @mixin tabletToDesktop {
      display: flex;
    }
  }

  .survey-container-mobile {
    display: flex;
    margin-bottom: 5px;
    @mixin tabletToDesktop {
      display: none;
    }
  }
  .google-ad-top {
    text-align: center;
  }
  .google-ad-side {
    width: 300px;
    position: sticky;
    align-self: center;
    top: 0;
  }
  .search-results--products + .container + div[data-dy-embedded-object='true'] {
    margin: 12px 0 0 12px;
    overflow: hidden;
    border-radius: var(--border-radius);
  }
`;
